<kodit-info-container>
  <div body-full>
    <kodit-paket-info class="kodit-paket-info"></kodit-paket-info>
    <div class="p-mt-5">
      <kodit-korisnicka-grupa-list></kodit-korisnicka-grupa-list>
      <kodit-korisnik-table></kodit-korisnik-table>
    </div>
  </div>
</kodit-info-container>
